// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import ReactSelect from 'react-select';
import { intlShape } from 'react-intl';

import '../../assets/styles/select.css';
import icons from '../../assets/styles/icons.scss';
import style from './Select.scss';

export type Option = {
  value: string | number;
  label?: string;
  labelId?: string;
  image?: string;
  icon?: string;
  data?: any;
};

type Props = {
  +value: any;
  +handleChange: (value: Option) => void | Promise<any>;
  +options: Option[];
  +placeholder?: string;
  +className?: { [key: string]: string };
  +disabled?: boolean;
  +searchable?: boolean;
  +handleFocus?: () => void;
  +hasErrorIcon?: boolean;
  +hasError?: boolean;
  +id?: string;
  +staticOptions?: Option[];
  +staticOptionDirection?: 'top' | 'bottom';
  +hideOptions?: boolean;
  +errors?: string[];
};

export default class Select extends Component<Props, void> {
  static defaultProps = {
    searchable: false,
  };

  renderOption = (option: Option) => {
    const label = option.labelId ? this.context.intl.formatMessage({
      id: option.labelId,
    }) : option.label;
    if (!option.icon && !option.image) return label;
    else return (
      <span className="icon-wrapper">
        {option.image && <img src={option.image}
                              alt={option.label}/>}
        {option.icon && <i className={option.icon}/>}
        <span className="value">{label}</span>
      </span>);
  };

  renderValue = (option: Option) => {
    const label = option.labelId ? this.context.intl.formatMessage({
      id: option.labelId,
    }) : option.label;
    if (!option.icon && !option.image) return label;
    else return (
      <span className="icon-wrapper">
         {option.image && <img src={option.image}
                               alt={option.label}/>}
        {option.icon && <i className={option.icon}/>}
        <span className="value">{label}</span>
      </span>);
  };

  renderArrow = ({ isOpen }: { isOpen: boolean }) => {
    const { hasError, hideOptions, errors } = this.props;
    return <i className={classNames(style.selectArrowIcon,
      { [style.error]: hasError && errors && errors[0] !== 'unscrapped' },
      { [style.yellow]: errors && errors[0] === 'unscrapped' },
      { [icons.iconChevronDownMedium]: !isOpen || (isOpen && hideOptions) },
      { [icons.iconChevronUpMedium]: isOpen && !hideOptions })}/>
  };

  handleFocus() {
    const { handleFocus } = this.props;
    if (handleFocus) {
      handleFocus();
    }
  }

  generatePlaceholderNode() {
    const { placeholder, hasError, hasErrorIcon } = this.props;
    if (hasError && hasErrorIcon) {
      return <Fragment>
        <i className={classNames(icons.symbolWarning, style.selectErrorIcon)}/>
        <span style={{ verticalAlign: 'middle' }}>{placeholder}</span>
      </Fragment>;
    } else {
      return <span>{placeholder}</span>;
    }
  }


  render() {
    const {
      id, value, options, handleChange, className, disabled, searchable,
      staticOptions, staticOptionDirection, hideOptions,
    } = this.props;
    let myOptions = options;
    if (staticOptions) {
      if (staticOptionDirection === 'top') {
        myOptions.unshift(...staticOptions);
      } else if (staticOptionDirection === 'bottom') {
        myOptions.push(...staticOptions);
      }
    }

    return (
      <ReactSelect value={value}
                   className={classNames(className)}
                   onChange={handleChange}
                   options={myOptions}
                   searchable={searchable}
                   clearable={false}
                   disabled={disabled}
                   placeholder={this.generatePlaceholderNode()}
                   optionRenderer={this.renderOption}
                   valueRenderer={this.renderValue}
                   arrowRenderer={this.renderArrow}
                   onFocus={this.handleFocus.bind(this)}
                   inputProps={{ id, autoComplete: 'off', autoCorrect: 'off', spellCheck: 'off' }}
                   menuContainerStyle={hideOptions ? { display: 'none' } : {}}
      />
    );
  }
}

Select.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  searchable: PropTypes.bool,
  handleFocus: PropTypes.func,
  hasErrorIcon: PropTypes.bool,
  hasError: PropTypes.bool,
  id: PropTypes.string,
  hideOptions: PropTypes.bool,
  errors: PropTypes.array,
};

Select.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/elements/Select/Select.jsx